import React from 'react';
import { populate } from './../utils/populate.js';

class PractitionersMap extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
    };

    this.mapDraw = this.mapDraw.bind(this);
  }

  componentDidMount() {
    this.mapDraw()
  }

  mapDraw() {

    var e, t = this,
      n = new google.maps.StyledMapType([{
        stylers: [{
          hue: "#00aec7"
        }, {
          visibility: "simplified"
        }, {
          saturation: -60
        }, {
          weight: .2
        }]
      }], {
        name: "CSS"
      }),
      r = "css_style";

    e = new google.maps.Map(document.getElementById("react--map"), {
      center: {
        lat: 54,
        lng: -2
      },
      zoom: 8,
      scrollwheel: false,
      mapTypeControlOptions: {
        mapTypeIds: [google.maps.MapTypeId.TERRAIN, r]
      },
      disableDefaultUI: true
    }), e.mapTypes.set(r, n), e.setMapTypeId(r);

    for (var a = new google.maps.LatLngBounds, o = 0; o < this.props.data.length; o++) {
      var i = this.props.data[o];
      var s = new google.maps.MarkerImage("/themes/nhs/pins/mapicon_" + (o + 1) + ".png", null, null, null, new google.maps.Size(40, 40));
        var l = new google.maps.Marker({
          map: e,
          icon: s,
          position: {
            lat: i.latt,
            lng: i.long
          },
          title: t.props.titles[o]
        });

      google.maps.event.addListener(l, "click", function(e, t) {
        return function() {
          if (document.documentElement.scrollTop > 0) var e = document.documentElement;
          else var e = document.body;
          var n = document.getElementById("practioner--" + (t + 1)),
            r = n.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop - 32;

          // window.scrollTo(0, r)
          window.scrollTo({
            top: r,
            behavior: "smooth"
          });
        }
      }(l, o))
    }
    l && a.extend(l.getPosition()), e.fitBounds(a);
    var u = google.maps.event.addListener(e, "bounds_changed", function(e) {
      this.setZoom(8), google.maps.event.removeListener(u)
    })
  }

  render() {
    this.props.data.map(function(item, index) {
      return(
        <p key={index}>lat : {item.latt} ,long : {item.long}</p>
      )
    })
      return(
        <div className="practitioners--map">
          <div className="map">
            <div className="container">
              <div id="react--map" >
              </div>
            </div>
          </div>
        </div>
      )
  }
}

export default PractitionersMap;











